import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeposits = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M12 8.70143C10.3419 8.28357 9.80796 7.82857 9.80796 7.15071C9.80796 6.37071 10.548 5.82286 11.7752 5.82286C13.0679 5.82286 13.555 6.43571 13.5925 7.34571H15.1944C15.1475 6.10143 14.3794 4.95929 12.8618 4.58786V3H10.6792V4.56929C9.26464 4.86643 8.13115 5.77643 8.13115 7.17857C8.13115 8.84071 9.52693 9.67643 11.5597 10.1593C13.3864 10.5864 13.7518 11.2271 13.7518 11.8957C13.7518 12.3879 13.3864 13.1864 11.7845 13.1864C10.2857 13.1864 9.69555 12.5179 9.61124 11.6636H8C8.09368 13.2421 9.274 14.1336 10.6792 14.4214V16H12.8712V14.4493C14.2951 14.18 15.4192 13.3721 15.4286 11.8771C15.4192 9.83429 13.6487 9.12857 12 8.70143Z" }),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 13C3.55228 13 4 13.4477 4 14V16C4 17.1046 4.89543 18 6 18H18C19.1046 18 20 17.1046 20 16V14C20 13.4477 20.4477 13 21 13C21.5523 13 22 13.4477 22 14V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V14C2 13.4477 2.44772 13 3 13Z"
		})
	]
});
const ForwardRef = forwardRef(SvgDeposits);
export default ForwardRef;
